module.exports = __webpack_public_path__ + "img/image 1.3692c7e7.svg";